'use strict';
import {itemModel} from "../models/itemmodel.js";

export class ItemMessagesCtrl
{
	$filter;
	$scope;
	notify;
	jsDataService;
	$http;
	$mdDialog;
	classif;
	settingsData;
	
	showAdd = false;
	newMessageTab = 0;
	newmessage = {
		attachments: []

	};
	newmessageSubmitted = false;
	
	data = [];
	total = 0;
	promise;
	
	addMessageData = [];
	addMessagePromise;
	
	addMessageOptions = {
		boundaryLinks: false,
		limitSelect: true,
		pageSelect: true
	};
	addMessageLimitOptions = [10, 20, 50, 100];
	addMessageQuery = {
		order: '',
		limit: 10,
		page: 1,
		filters: {
			query: ''
		}
	};
	addMessageDefaultQuery = {
		order: '',
		limit: 10,
		page: 1,
		filters: {
			query: ''
		}
	};
	addMessageTotal = 0;
	addMessageQueryWatcher;
	
	registerItemUrl;
	submitted = false;
	progress = false;
	
	cfg = {
		maxFiles: 4,
		fileFilter: {}
	};
	flow;
	dragClass = '';
	defaultTemplate = {};
	
	constructor($scope, $filter, $http, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$filter = $filter;
		this.$scope = $scope;
		this.$http = $http;
		this.$mdDialog = $mdDialog;
		this.notify = notify;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.settingsData = this.jsDataService.get('settingsData', {});
		this.item = new itemModel(this.jsDataService.get('storeditemData', {}));
		this.cfg.maxFiles = this.jsDataService.get('cfgMaxFiles', 4);
		this.cfg.fileFilter = this.jsDataService.get('cfgFileFilter', {});
		// workaround https://github.com/daniel-nagy/md-data-table/issues/579
		this.$scope.addMessageLoadData = () => this.addMessageLoadData();
		this.registerItemUrl = this.jsDataService.get('actionRegisterItemUrl');
		this.setDefaultData();
		
		const urlParams = new URLSearchParams(window.location.search);
		
		if(urlParams.get('reply') === '1'){
			this.addNew();
		}
	}
	
	$onInit(){
		this.loadData();
	}

	setDefaultData(){
//		if(typeof(this.classif.templates[0]) !== 'undefined'){
//			this.newmessage.template_id = this.classif.templates[0].id;
//		}
		if(typeof(this.settingsData.fromemail) !== 'undefined'){
			this.newmessage.from_email = this.settingsData.fromemail;
		}
		if(typeof(this.item.email) !== 'undefined'){
			this.newmessage.to_email = this.item.email;
		}
	}

	addNew(e){
		this.newMessageTab = 0;
		this.showAdd = true;
//		this.addMessageLoadData();
		this.setDefaultData();
//		if(typeof(this.classif.templates[0]) !== 'undefined'){
//			this.templateChanged();
//		}
		const self = this;
		this.addMessageQueryWatcher = this.$scope.$watch(function(){
			return angular.toJson(self.addMessageQuery);
		},function(){
			self.addMessageLoadData();
		});
	}

	templateChanged(){
		let val = this.$filter('filter')(this.classif.templates, {id: this.newmessage.template_id}, true);
		if(val.length > 0){
			let selectedTemplate = val.shift();
			let str = [];
			const fields = ['type_title', 'location_title', 'link', 'comment'];
			for (const field of fields) {
				if(typeof(this.item[field]) !== 'undefined' && this.item[field] !== '' && this.item[field] !== null){
					str.push(this.$filter('tr')(field)+':	'+this.item[field]);
				}
			}
			if(typeof(selectedTemplate.add_to) !== 'undefined' && selectedTemplate.add_to !== '' && selectedTemplate.add_to !== null && typeof(selectedTemplate.body) !== 'undefined' && selectedTemplate.body !== '' && selectedTemplate.body !== null){
				switch(selectedTemplate.add_to){
					case 'top':
						this.newmessage.body = selectedTemplate.body+'\n\n\n\n\n';
						this.newmessage.body += str.join('\n');
						break;
					case 'bottom':
						this.newmessage.body = str.join('\n');
						this.newmessage.body += '\n\n\n\n\n'+selectedTemplate.body;
					default:
						break;
					
				}
				
			}
			else{
				this.newmessage.body = str.join('\n');
			}
			

			if(typeof(selectedTemplate.from_email) !== 'undefined' && selectedTemplate.from_email !== '' && selectedTemplate.from_email !== null){
				this.newmessage.from_email = selectedTemplate.from_email;
			}
			if(typeof(selectedTemplate.subject) !== 'undefined' && selectedTemplate.subject !== '' && selectedTemplate.subject !== null){
				this.newmessage.subject = selectedTemplate.subject;
			}
		}

	}

	closeAddNew(){
		this.showAdd = false;
		this.addMessageQueryWatcher();
		this.addMessageClearQuery();
	}
	
	
	newMessageIncorrect(){
		if(typeof(this.newmessage.from_email) === 'undefined' || this.newmessage.from_email === ''){
			return true;
		}
		if(typeof(this.newmessage.to_email) === 'undefined' || this.newmessage.to_email === ''){
			return true;
		}
		if(typeof(this.newmessage.subject) === 'undefined' || this.newmessage.subject === ''){
			return true;
		}
		if(typeof(this.newmessage.body) === 'undefined' || this.newmessage.body === ''){
			return true;
		}
//		if(typeof(this.newmessage.template_id) === 'undefined' || this.newmessage.template_id === ''){
//			return true;
//		}
		return false;
	}
	
	addNewMessage(){
		const url = this.jsDataService.get('actionAddMessageUrl');
		if(url){
			this.newmessageSubmitted = true;
			const ctrl = this;
			this.$http({
				url: url,
				method: 'POST',
				responseType: 'json',
				data: this.getNewMessagePostData()
			}).then(function(response){
				ctrl.newmessageSubmitted = false;
				if(response.data){
					if(response.data.success){
						ctrl.closeAddNew();
						ctrl.newmessage = {
							attachments: []
						};
						ctrl.loadData();
					}
					if(response.data.message){
						ctrl.notify(response.data.message, !response.data.success);
					}
				}
				else{
//					ctrl.newmessage = {};
					ctrl.notify('Communication Error', true);
				}
			}, function(response){
				console.log("HTTP ERROR");
				console.log(response);
				ctrl.notify('Network error, Status: ' + response.status, true);
//				ctrl.newmessage = {};
				ctrl.newmessageSubmitted = false;
			});
		}
		else{
			this.notify('Undefined URL', true);
		}
	}
	
	getNewMessagePostData(){
		let postData = angular.copy(this.newmessage);
		if(typeof(postData.attachments) !== 'undefined'){
			for(let ph of postData.attachments){
				if(ph.isFlow){
					delete ph.flowFile;
				}
			}
		}
		return postData;
	}
	
	loadData(){
		const url = this.jsDataService.get('cfgDataUrl');
		if(url){
			const self = this;
			this.promise = this.$http({
				url: url,
				method: 'GET',
			}).then(function(response){
				if(response.data.success){
					self.data = response.data.data;
					self.total = response.data.total;
				}
				if(response.data.message){
					self.notify(response.data.message, !response.data.success);
				}
			}, function(response){
				console.log("HTTP ERROR");
				console.log(response);
			});
		}
	}
	
	addMessageLoadData(){
		this.addMessageDataLoader();
	}
	
	addMessageDataLoader(){
		const url = this.jsDataService.get('cfgQueryDataUrl');
		if(url){
			const self = this;
			this.addMessagePromise = this.$http({
				url: url,
				method: 'GET',
				params: this.addMessageQuery
			}).then(function(response){
				if(response.data.success){
					self.addMessageData = response.data.data;
					self.addMessageTotal = response.data.total;
				}
				if(response.data.message){
					self.notify(response.data.message, !response.data.success);
				}
			}, function(response){
				console.log("HTTP ERROR");
				console.log(response);
			});
		}
	}
	
	addMessageClearQuery(){
		this.addMessageQuery.filters = angular.copy(this.addMessageGetDefaultQuery().filters);
	}
	
	addMessageGetDefaultQuery(){
		return this.addMessageDefaultQuery;
	}
	
	addMessageIsFilters(){
		var o = angular.copy(this.addMessageQuery.filters);
		var d = this.addMessageDefaultQuery.filters;
		if(angular.equals(o, d)){
			return false;
		}
		return true;
	}
	
	actionRemove(e, msg){
		const url = this.jsDataService.get('actionRemoveMessageUrl');
		if(url){
			const ctrl = this;
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			let confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.textContent(this.varReplace(confirmTexts.content, msg))
				.ariaLabel(confirmTexts.title)
				.targetEvent(e)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);

			this.$mdDialog.show(confirm).then(function () {
				ctrl.newmessageSubmitted = true;
				ctrl.$http({
					url: url,
					method: 'POST',
					responseType: 'json',
					data: {
						message_id: msg.id
					}
				}).then(function(response){
					ctrl.newmessageSubmitted = false;
					if(response.data){
						if(ctrl.showAdd){
							ctrl.addMessageLoadData();
						}
						ctrl.loadData();
						if(response.data.message){
							ctrl.notify(response.data.message, !response.data.success);
						}
					}
					else{
						ctrl.notify('Communication Error', true);
					}
				}, function(response){
					console.log("HTTP ERROR");
					console.log(response);
					ctrl.notify('Network error, Status: ' + response.status, true);
					ctrl.newmessageSubmitted = false;
				});
			}, function () {});
		}
		else{
			this.notify('Undefined URL', true);
		}
	}
	
	actionPreview(e, msg){
		this.$mdDialog.show({
			controller: "MessagePreview",
			templateUrl: 'reports/message_preview.html',
			parent: angular.element(document.body),
			targetEvent: e,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				id: msg.id
			}
		})
		.then(function(result) {
			
		}, function () {

		});
	}
	
	varReplace(text, params){
		for(let i in params){
			let reg = new RegExp("\\{"+i+"\\}", "i");
			text = text.replace(reg, params[i]);
		}
		return text;
	}
	
	showRegisterButton(){
		return (this.registerItemUrl && this.registerItemUrl !== '');
	}
	
	isValidMessages(){
		return (this.data.length > 0);
	}
	
	actionRegister(){
		if(this.showRegisterButton()){
			this.submitted = true;
			this.progress = true;
			const self = this;
			this.$http({
				url: this.registerItemUrl,
				method: 'GET',
				responseType: 'json',
			}).then(function(response){
				self.progress = false;
				if(response.data){
					if(response.data.success){
						if(typeof(response.data.url) !== 'undefined'){
							window.location.href = response.data.url;
						}
						else{
							self.submitted = false;
						}
					}
					else{
						self.submitted = false;
					}
					if(response.data.message){
						self.notify(response.data.message, !response.data.success);
					}
				}
				else{
					self.submitted = false;
					console.log(response);
					self.notify('Communication Error', true);
				}
			}, function(response){
				console.log("HTTP ERROR");
				console.log(response);
				self.notify('Network error, Status: ' + response.status, true);
				self.progress = false;
				self.submitted = false;
			});
		}
	}
	
	fileUploaded($file, $message, $flow){
		if($file.response.success){
			let f = this.$filter('filter')(this.newmessage.attachments, {nrId: $file.uniqueIdentifier}, true);
			if(f.length > 0){
				let attachment = f.shift();
				attachment.file_id = $file.response.fileId;
				attachment.done = true;
			}
		}
	}
	
	fileSubmited($files){
		this.flow.upload();
	}
	
	filesAdded($files){
		if(typeof(this.cfg.maxFiles) !== 'undefined' && $files.length > this.cfg.maxFiles){
			return false;
		}
		return true;
	}
	
	fileAdded($file){
		const ext = $file.getExtension();
		if(typeof(this.cfg.fileFilter[ext]) === 'undefined' || !this.cfg.fileFilter[ext]){
//			console.log("Extension '" + ext + "' not allowed");
			return false;
		}
		if(typeof(this.cfg.fileSize) !== 'undefined' && $file.size > this.cfg.fileSize){
//			console.log("Size of " + this.cfg.imageSize + " exeded with " + $file.size);
			return false;
		}
		if(!this.activeUpload()){
//			console.log("Max images of " + this.cfg.maxImages + " exeded");
			return false;
		}
		this.addFlowFile($file);
		return true;
	}
	
	fileRemove(attachment){
		if(attachment.isFlow){
			attachment.flowFile.cancel();
		}
		this.newmessage.attachments = this.$filter('filter')(this.newmessage.attachments, {nrId: '!' + attachment.nrId}, true);
	}
	
	activeUpload(){
		if(typeof(this.cfg.maxFiles) !== 'undefined' && (this.newmessage.attachments.length + 1) > this.cfg.maxFiles){
			return false;
		}
		return true;
	}
	
	classOnDrag(value){
		if(this.activeUpload()){
			this.dragClass = value;
		}
	}
	
	classOffDrag(value){
		this.dragClass = value;
	}
	
	addFlowFile($file){
		let attachment = {
			file_id: '0',
			nrId: $file.uniqueIdentifier,
			file_name: $file.name,
			isFlow: true,
			flowFile: $file,
			done: false
		};
		this.newmessage.attachments.push(attachment);
	}
	
	fileUploading(){
		if(typeof(this.flow) === 'undefined'){
			return true;
		}
		return this.flow.isUploading();
	}
}